import { render, staticRenderFns } from "./RomList.vue?vue&type=template&id=194174f2&scoped=true"
import script from "./RomList.vue?vue&type=script&lang=js"
export * from "./RomList.vue?vue&type=script&lang=js"
import style0 from "./RomList.vue?vue&type=style&index=0&id=194174f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194174f2",
  null
  
)

export default component.exports